module.exports = __webpack_public_path__ + "img/zhezhao-2.c25e56bc.png";